function extractPipelineSchemaLibraryData({ pipeline, schemaLibraryVersion }) {
  const { id: pipelineId, name: pipelineName, writekey, clusterId } = pipeline;
  const { id: schemaLibraryVersionId, schemaLibrary, eventSchemas, version } = schemaLibraryVersion;
  const { name: schemaLibraryName } = schemaLibrary;

  return {
    pipelineId,
    pipelineName,
    writekey,
    clusterId,
    schemaLibraryVersionId,
    schemaLibraryName,
    eventSchemas,
    version,
  };
}

export default extractPipelineSchemaLibraryData;
